import React from "react";

const GoogleIcon = ({ fill = "#1a1a1a", ...delegated }) => {
  return (
    <svg
      width="57"
      height="15"
      viewBox="0 0 57 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...delegated}
    >
      <path
        d="M41.2468 8.92073L42.4261 9.71793C42.1099 10.1979 41.6814 10.591 41.1788 10.8619C40.6763 11.1328 40.1154 11.2731 39.5462 11.2703C37.5818 11.2703 36.1187 9.72893 36.1187 7.76741C36.1187 5.67965 37.5968 4.26367 39.3803 4.26367C41.1638 4.26367 42.0535 5.71164 42.3381 6.49286L42.4933 6.89105L37.8706 8.82728C38.2225 9.53023 38.7703 9.88713 39.5462 9.88713C40.3222 9.88713 40.8592 9.49903 41.2468 8.91652V8.92073ZM37.6225 7.65797L40.709 6.35733C40.5388 5.9221 40.0318 5.6123 39.4267 5.6123C38.6566 5.6123 37.5868 6.30513 37.6225 7.65797Z"
        fill={fill}
      />
      <path
        d="M33.8921 0.692627H35.381V10.9504H33.8921V0.692627Z"
        fill={fill}
      />
      <path
        d="M31.5451 4.53643H32.9825V10.766C32.9825 13.3513 31.4778 14.4162 29.7001 14.4162C28.0245 14.4162 27.0161 13.273 26.6394 12.3445L27.9573 11.7889C28.1955 12.3605 28.769 13.0365 29.7001 13.0365C30.8421 13.0365 31.5451 12.3184 31.5451 10.9756V10.4705H31.4936C31.1525 10.8915 30.4977 11.2678 29.6736 11.2678C27.9473 11.2678 26.3647 9.74152 26.3647 7.77498C26.3647 5.80845 27.9473 4.2561 29.6736 4.2561C30.496 4.2561 31.1525 4.62819 31.4936 5.03732H31.5451V4.53222V4.53643ZM31.6488 7.77751C31.6488 6.54001 30.8371 5.6384 29.803 5.6384C28.769 5.6384 27.8834 6.54001 27.8834 7.77751C27.8834 8.99986 28.7623 9.88212 29.8064 9.88212C30.8504 9.88212 31.6521 8.99649 31.6521 7.77751H31.6488Z"
        fill={fill}
      />
      <path
        d="M18.1919 7.75147C18.1919 9.77193 16.6407 11.2543 14.7377 11.2543C12.8347 11.2543 11.2852 9.76513 11.2852 7.75147C11.2852 5.72179 12.8364 4.24268 14.7385 4.24268C16.6407 4.24268 18.1919 5.72179 18.1919 7.75147ZM16.6822 7.75147C16.6822 6.48871 15.7826 5.6275 14.7377 5.6275C13.6928 5.6275 12.794 6.49292 12.794 7.75147C12.794 9.01002 13.692 9.87463 14.7377 9.87463C15.7834 9.87463 16.6798 8.99991 16.6798 7.75147H16.6822Z"
        fill={fill}
      />
      <path
        d="M25.7368 7.76961C25.7368 9.79003 24.1865 11.2725 22.2834 11.2725C20.3804 11.2725 18.8301 9.79003 18.8301 7.76961C18.8301 5.74919 20.3812 4.26587 22.2834 4.26587C24.1856 4.26587 25.7368 5.73236 25.7368 7.76961ZM24.2222 7.76961C24.2222 6.50685 23.3225 5.64565 22.2785 5.64565C21.2344 5.64565 20.3339 6.50685 20.3339 7.76961C20.3339 9.03233 21.2336 9.89353 22.2776 9.89353C23.3217 9.89353 24.2222 9.00964 24.2222 7.76961Z"
        fill={fill}
      />
      <path
        d="M5.60718 9.73383C3.44106 9.73383 1.74552 7.9609 1.74552 5.7637C1.74552 3.5665 3.44106 1.79274 5.60718 1.79274C6.59609 1.7794 7.55033 2.16204 8.26295 2.85767L9.30202 1.80369C8.41981 0.950897 7.24629 0.299316 5.60718 0.299316C2.63935 0.299316 0.14209 2.75328 0.14209 5.7637C0.14209 8.77411 2.63935 11.228 5.60718 11.228C7.20977 11.228 8.41981 10.6935 9.36593 9.69673C10.3378 8.71098 10.6374 7.32615 10.6374 6.20398C10.635 5.87515 10.6055 5.54711 10.5494 5.22324H5.60718V6.6813H9.12691C9.024 7.59386 8.73933 8.21766 8.32022 8.64279C7.81396 9.16223 7.01225 9.73723 5.60635 9.73723L5.60718 9.73383Z"
        fill={fill}
      />
    </svg>
  );
};

export { GoogleIcon };
